import { useEffect } from 'react'

const BazaarVoiceScript = ({ theme = 'main_site' }) => {
  const BVDeploaymentZone = 'main_site' || theme.replace(/-/g, '')
  const BVEnvironment = process.env.GATSBY_ACS_API_URL.includes('staging')
    ? 'staging'
    : 'production'

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const existingScript = document?.getElementById('BVDynamicScript')
      if (!existingScript) {
        const BV_SCRIPTS = {
          src: `https://apps.bazaarvoice.com/deployments/goodles/${BVDeploaymentZone}/${BVEnvironment}/en_US/bv.js`,
          type: 'text/javascript',
          async: true,
          defer: false,
        }
        let r = document.createElement('script')

        r.setAttribute('defer', BV_SCRIPTS.defer)
        r.setAttribute('async', BV_SCRIPTS.async)
        r.setAttribute('id', 'BVDynamicScript')
        r.src = BV_SCRIPTS.src

        document.head.appendChild(r)
      }
    }
  }, [])

  return null
}

export default BazaarVoiceScript
